export default {
  cotacoes(state) {
    return state.cotacoes;
  },
  viewType(state) {
    return state.viewType;
  },
  selectedStatus(state) {
    return state.selectedStatus;
  },
  viewOptions(state) {
    return state.viewOptions;
  },
  statusOptions(state) {
    return state.statusOptions;
  },
  fornecedores(state) {
    return state.fornecedores;
  },
  cotacoesItens(state) {
    return state.cotacoesItens;
  },
  showEspecificacao(state) {
    return state.showEspecificacao;
  },
  showEspecificacaoFornecedor(state) {
    return state.showEspecificacaoFornecedor;
  },
  showPrecoSemIcms(state) {
    return state.showPrecoSemIcms;
  },
  showPrecoComDifal(state) {
    return state.showPrecoComDifal;
  },
  showPrecoComIpi(state) {
    return state.showPrecoComIpi;
  },
  tipoVisualizacao(state) {
    return state.tipoVisualizacao;
  },
  showPrecoTarget(state) {
    return state.showPrecoTarget;
  },
  showPercentualIcms(state) {
    return state.showPercentualIcms;
  },
  situacao(state) {
    return state.situacao;
  },
  hasCustomFilters(state) {
    return [
      state.fornecedores && state.fornecedores.length,
      state.cotacoesItens && state.cotacoesItens.length,
      state.situacao && state.situacao.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(state.selectedStatus.value);
    }
    if (state.fornecedores && state.fornecedores.length) {
      const fornecedores = state.fornecedores.map(p => p.id);
      filters.push(`fornecedor in (${fornecedores.join(', ')})`);
    }
    if (state.cotacoesItens && state.cotacoesItens.length) {
      const produtos = state.cotacoesItens.map(p => p.id);
      filters.push(`produto in (${produtos.join(', ')})`);
    }
    return filters.join(' and ');
  },
};
